import { memo } from 'react';

type Props = {
  text: undefined | null | string;
  addLink?: boolean;
  className?: string;
};

const regexUrl = /(https?:\/\/[\w!?/+\-_~=;.,*&@#$%'[\]]+)/g;

export const splitUrlText = (text: string) => {
  return text.split(regexUrl);
};

export const Nl2Br = memo((props: Props) => {
  const { addLink, className, text } = props;
  const regexNewLine = /(\n)/g;

  if (!text) {
    return null;
  }

  return (
    <>
      {text.split(regexNewLine).map((line, i) => {
        if (line.match(regexNewLine)) {
          return <br key={i} />;
        }
        return addLink
          ? splitUrlText(line).map((link, j) => {
              if (link.match(regexUrl)) {
                return (
                  <a
                    className={className}
                    href={link}
                    key={j}
                    rel="noopener"
                    target="_blank"
                  >
                    {link}
                  </a>
                );
              }
              return link;
            })
          : line;
      })}
    </>
  );
});

Nl2Br.displayName = 'Nl2Br';
